/* global jQuery */

/**
 * Class to handle form validation for order minimum and maximum quantities.
 * @since 3.12.0
 */
class OrderMinMaxFormValidation {
    /**
     * @type {jQuery} jQuery object for the minimum quantity input field
     */
    minField;

    /**
     * @type {jQuery} jQuery object for the maximum quantity input field
     */
    maxField;

    /**
     * Creates an instance of OrderMinMaxFormValidation.
     * @param {jQuery} minField - jQuery object for the minimum quantity input field
     * @param {jQuery} maxField - jQuery object for the maximum quantity input field
     */
    constructor( minField, maxField ) {
        this.minField = minField;
        this.maxField = maxField;
        this.initEvents();
    }

    /**
     * Initializes event listeners for the quantity fields.
     * @private
     */
    initEvents() {
        this.minField.on( 'change', this.validateFields.bind( this ) );
        this.maxField.on( 'change', this.validateFields.bind( this ) );
    }

    /**
     * Validates the minimum and maximum quantity fields.
     * Ensures that both fields contain non-negative values and max is not less than min.
     * @private
     */
    validateFields() {
        let minQuantity = this.parseQuantity( this.minField );
        let maxQuantity = this.parseQuantity( this.maxField );

        minQuantity = Math.max( 0, minQuantity );
        maxQuantity = Math.max( 0, maxQuantity );

        if ( maxQuantity > 0 && maxQuantity < minQuantity ) {
            maxQuantity = minQuantity;
        }

        this.minField.val( minQuantity );
        this.maxField.val( maxQuantity );
    }

    /**
     * Parses the quantity value from a field.
     * @param {jQuery} field - The field to parse the value from
     * @return {number} The parsed quantity value
     * @private
     */
    parseQuantity( field ) {
        const value = field.val();
        return value === '' ? 0 : Math.max( 0, parseInt( value, 10 ) );
    }
}

export default OrderMinMaxFormValidation;
